import { between } from 'polished'
import styled from 'styled-components'

import media from '../../utils/media'
import Badge from '../Badge'
import { SectionWrapper } from '../shared/Section'
import Title from '../shared/Title'

export const HeroWrapper = styled(SectionWrapper)`
  min-height: calc(100vh - ${({ afterSkew }) => (afterSkew ? 201 : 121)}px);
  display: flex;

  ${media.lessThan('sm')`
    padding-top: 100px;
  `}
`

export const HeroContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const HeroCaption = styled.div`
  width: 400px;
  flex-shrink: 0;

  ${media.greaterThan('xxl')`
    width: 500px;
  `}

  ${media.lessThan('md')`
    width: 100%;
  `}
`

export const HeroBadge = styled(Badge)``

export const HeroTitle = styled(Title)`
  margin-top: 24px;
`

export const HeroText = styled.p`
  margin-top: 24px;
  margin-bottom: 24px;
  font-size: ${between('16px', '18px')};
`

export const HeroFigure = styled.div`
  width: 100%;
  padding-left: 32px;
  padding-right: 32px;
  margin-left: 32px;
`
